/**
 * @enum {string}
 */
const PlayInsertionType = Object.freeze({
    After: "after",
    Before: "before",
    Replace: "replace"
});

export default PlayInsertionType;
